import React from 'react';

export type ILinkContent = {
  label?: string | JSX.Element;
  href?: string;
  isExternal?: boolean;
  tailwindCss?: string;
};

export const LinkContent = (props: ILinkContent) => {
  const { label, href, isExternal, tailwindCss } = props;

  return (
    <a
      href={href}
      target={isExternal ? '_blank' : undefined}
      rel={'noopener noreferrer'}
      className={tailwindCss + ' text-gray-600'}
    >
      {label}
    </a>
  );
};
